/**
 * Mutación que almacena la lista de afiliaciones para ser mostradas en la seccion de afiliaciones
 * que puede ver cualquier usuario o en la sección de mis afiliaciones (QUE SOLO PUEDE VER UN USUARIO QUE HAYA INGRESASO SESIÓN).
 * @param {State} state Estado de Vue
 * @param {*} plans Lista de planes, ya sea para la sección de afiliaciones que ven todos los usuarios
 *             o para la lista de afiiaciones que sale en el dashboard de una organización.
 */
export function setPlans(state, plans) {
    state.plans = plans
}

/**
 * Mutación que guarda la información de un plan, ya sea para ver el detalle de ese plan o para editarlo.
 * @param {State} state Estado de Vue
 * @param {Object} plan Objeto del plan
 */
export function setCurrentPlan(state, plan) {
    state.currentPlan = plan
}
